import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import DrinkCreator from './components/DrinkCreator';
import BlackjackGame from './components/BlackjackGame';

const App: React.FC = () => {
  return (
    <div className="App">
      <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/create-drink" element={<DrinkCreator />} />
            <Route path="/blackjack" element={<BlackjackGame />} />
          </Routes>
      </Router>
    </div>
  );
};

export default App;
